import { ChangeDetectorRef, Component, OnInit } from '@angular/core';


import { DeviceDetectorService } from 'ngx-device-detector';
import { banner } from '@services/decorators/class.decorator';

import { WindowRefService } from '@shared/window-ref';


import { ActivatedRoute, ParamMap } from '@angular/router';


import { UserService } from '@services/user.service';
import { StorageService } from '@services/storage.service';

import APP_CONFIG from 'src/app/config/app.config';

import { BannerInterface } from '@interfaces/banner.interface';

import { BannerBase } from '../banner.base';

@banner({
    position: 10,
})
@Component({
    selector: 'app-banner[pop-up]',
    templateUrl: './pop-up.component.html',
    styleUrls: ['./pop-up.component.scss'],

})
export class BannerPopUpComponent extends BannerBase implements OnInit {
    public bannerPositionId = 10;
    public wasClosed = false;
    public constructor(public deviceService: DeviceDetectorService, public user: UserService,
        protected ref: ChangeDetectorRef,
        protected win: WindowRefService,
        protected router: ActivatedRoute,
        private storage: StorageService,
    ) {
        super(deviceService, ref, win);
    }

    ngOnInit(): void {
        this.router.queryParamMap.subscribe((params: ParamMap) => {
            if (params.has('nobanner')) {
                this.close();
            }
        });
    }

    public setBanner(banner: BannerInterface | null): void {
        super.setBanner(banner);
        const ntf = this.storage.get<string>(`${APP_CONFIG.bannerPopUpKey}-${this.banner?.id}`) || null;
        if (ntf === null) {
            this.storage.set(`${APP_CONFIG.bannerPopUpKey}-${this.banner?.id}`, '1');
        } else {
            this.close();
        }
    }

    get isLoggedIn(): boolean {
        return this.user.isLoggedIn;
    }

    /**
     * Dismiss banner
     */
    public close(): void {
        this.banner = null;
        this.wasClosed = true;
    }
}
